export const pxToRem = (px: number) => `${px / 16}rem`;

export const removeBackSlash = (route: string) => {
  if (route.startsWith('/')) {
    return route.substring(1);
  }
  return route;
};
